import axios from "axios";
import { PLAIN_TEXT } from "helpers/constant";
import { encryptId } from "helpers/cryptography";
import { encryptValues } from "helpers/cryptography";
import { decryptData } from "helpers/cryptography";
const API_URL = process.env.REACT_APP_API_URL;
// const PLAIN_TEXT = true;

export async function callApi({ url, body, headers, method }) {
  let authHeader = localStorage.getItem("authorization")
    ? { token: localStorage.getItem("authorization") }
    : {
        "admin-reset-token": localStorage.getItem("resetToken"),
      };
  let cryptoObj = { "plain-text": PLAIN_TEXT };

  const isFormData = typeof FormData !== "undefined" && body instanceof FormData;
  const encryptedBody = !PLAIN_TEXT && !isFormData ? encryptValues(body) : body;

  if (!PLAIN_TEXT && (method === "GET" || method === "DELETE")) {
    const urlParts = url.split("/");
    const lastPart = urlParts[urlParts.length - 1];
    if (/^[0-9a-fA-F]{24}$|^\d+$/.test(lastPart)) {
      urlParts[urlParts.length - 1] = encryptId(lastPart);
      url = urlParts.join("/");
    }
  }
  try {
    const result = await axios({
      url: API_URL + url,
      method: method,
      headers: { ...authHeader, ...headers, ...cryptoObj },
      data: encryptedBody,
      timeout: 120000,
      validateStatus: () => true,
    });

    const responseData = result?.data && !PLAIN_TEXT ? decryptData(result.data) : result.data;
    return {
      ...result,
      data: responseData,
    };
  } catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("authorization");
      localStorage.setItem("IsLogin", false);
      window.location.href = "/authentication/sign-in";
    } else if (error.response) {
      return error.response;
    } else {
      console.log("error >", error);
    }
  }
}
